import { HttpClient } from '@angular/common/http';
import { Directive } from '@angular/core';
import type { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { NG_ASYNC_VALIDATORS } from '@angular/forms';
import type { Observable } from 'rxjs';
import { debounceTime, filter, switchMap, tap } from 'rxjs';

@Directive({
    selector: '[appNhsNumberValidator]',
    exportAs: 'appNhsNumberValidator',
    providers: [{
        provide: NG_ASYNC_VALIDATORS,
        useExisting: NhsNumberValidator,
        multi: true
    }]
}) export class NhsNumberValidator implements AsyncValidator {

    constructor(
        private http: HttpClient
    ) { }

    validate(control: AbstractControl<any, any>): Observable<ValidationErrors> {
        return control.valueChanges.pipe(
            filter(value => !!value?.length),
            debounceTime(300),
            switchMap(value => this.http.get<any>(`/rpc/validate/nhs-number?value=${value}`)),
            tap(response => {
                if (!response.valid) {
                    return control.setErrors({ nhsNumber: response.message })
                }
            }),
        );
    }
}
